<template>
  <div class="text-nowrap">
    <b-button
      :disabled="disabled"
      @click="$emit('deleteToggle')"
      pill
      size="sm"
      variant="outline-danger"
      v-if="!noDelete && $store.state.app.permissions.includes(deletePerm)"
      >{{ $t("common.delete") }}</b-button
    >
    <b-button
      :disabled="disabled"
      @click="$emit('editToggle')"
      variant="outline-warning"
      pill
      size="sm"
      class="mx-1"
      v-if="!noEdit && $store.state.app.permissions.includes(editPerm)"
      >{{ $t("common.edit") }}</b-button
    >
  </div>
</template>

<script>
import { BButton } from "bootstrap-vue";
export default {
  components: {
    BButton,
  },
  props: ["deletePerm", "editPerm", "noEdit", "noDelete", "disabled"],
  data() {
    return {};
  },
};
</script>
